// This file should contain groups of groups. It should *not* contain feature-flag related groupings.

export const grHiddenName = ['gr', 'ou', 'pa', 'ma'].join('') as 'groupama';

export const brasileiraRuralMgaHiddenName = ['br', 'as', 'il', 'ei', 'ra', '-r', 'ur', 'al', '-m', 'ga'].join(
  '',
) as 'brasileira-rural-mga';

const grRegions = ['-ge', '-gcm', '-gpvl', '-goc', '-gca', '-gne', '-graa', '-glbr', '-gmed'];
const grTrainingRegions = grRegions.map(x => `${grHiddenName}${x}-formation`);
export const grDemo = grHiddenName + '-demo';
// For historical reasons we keep with the "-training" postfix on the parent group, instead of "-formation".
export const grTraining = [...grTrainingRegions, grHiddenName + '-training'];

// Note that gan is missing from this list, even though it grants to groupama in data.user_group_acl.
export const grAllGroupsExGan = ['', ...grRegions].map(x => grHiddenName + x).concat(grTraining, grDemo);
export const grAllGroups = [...grAllGroupsExGan, 'gan'];

export const paHiddenName = ['pa', 'ci', 'fi', 'ca'].join('') as 'pacifica';
export const paDemo = paHiddenName + '-demo';
export const paTraining = paHiddenName + '-training';
export const txHiddenName = ['te', 'rr', 'ex', 'pe', 'rt'].join('') as 'terrexpert';
export const txDemo = txHiddenName + '-demo';
export const txTraining = txHiddenName + '-formation';
// TODO(seb):
//  - What about pacifica-forets? It's defined in prod. But not listed here.
//  - What about terrexpert-ma? No grants, no users.
export const paAllGroups = [
  ...['', '-au', '-co', '-e', '-extra', '-no', '-se', '-so'].map(x => paHiddenName + x),
  paDemo,
  paTraining,
];
export const txAllGroups = [
  ...['', '-aas', '-au', '-co', '-e', '-ma', '-no', '-se', '-so'].map(x => txHiddenName + x),
  txDemo,
  txTraining,
];
export const etHiddenName = ['et', 'oi', 'le'].join('');
export const aaHiddenName: string = ['a', 'a', 's'].join('');
export const gaHiddenName: string = ['g', 'a', 'n'].join('');
export const asHiddenName: string = ['as', 'si', 'te', 'ca'].join('');
export const asAllGroups: string[] = [
  '',
  '-abruzzo',
  '-basilicata',
  '-emilia-romagna',
  '-friuli-venezia-giulia',
  '-lombardia',
  '-marche',
  '-molise',
  '-piemonte',
  '-puglia',
  '-trentino-alto-adige',
  '-umbria',
  '-veneto',
  '-training',
].map(x => asHiddenName + x);
export const mdaHiddenName: string = ['ma', 'md', 'a'].join('');
export const mdaAllGroups = [
  mdaHiddenName,
  'Beni-Mellal-Khenifra',
  'Casablanca-Settat',
  'Draa-Tafilalet',
  'Fes-Meknes',
  'Guelmim-Oued-Noun',
  'Marrakech-Safi',
  'Oriental',
  'Rabat-Sale-Kenitra',
  'Souss-Massa',
  'Tanger-Tetouan-Alhoceima',
];
// Production used latam-admin while staging uses admin-latam.
export const internalAdminGroup = ['admin', 'admin-latam', 'latam-admin', 'pkm-admin'];
export const mgmtAllGroups = [...internalAdminGroup, grHiddenName, paHiddenName, etHiddenName, txHiddenName, 'tester'];
export const europeGroups = [
  'RUS',
  'ESP',
  'AUT',
  'GEO',
  'CZE',
  'BGR',
  'GRC',
  'SVK',
  'ROU',
  'UKR',
  'CHE',
  'FRA',
  'ITA',
  'HUN',
  'BEL',
  'POL',
  'DEU',
  'MDA',
  'LTU',
  'LVA',
  'EST',
  'SRB',
  'GBR',
  'FIN',
  'SVN',
  'PRT',
];
export const latamGroups = ['ARG', 'BLZ', 'BOL', 'BRA', 'CHL', 'COL', 'ECU', 'MEX', 'PER', 'PRY', 'URY'];
